import { useContext, createContext } from "react";

export const BszPlannerContext = createContext(null);

export function useBszPlannerContext() {
  const context = useContext(BszPlannerContext);

  if (!context) {
    throw new Error(
      "useBszPlannerContext must be used inside BszPlannerContext.Provider",
    );
  }

  return context;
}
